import ChatGroupAPI from '../../../api/chatGroups';
import types from '../../mutation-types';

export const actions = {
  delete: async ({ commit }, id) => {
    commit(types.SET_CHAT_GROUP_UI_FLAG, { isDeleting: true });
    try {
      await ChatGroupAPI.delete(id);
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error(error);
      }
    } finally {
      commit(types.SET_CHAT_GROUP_UI_FLAG, { isDeleting: false });
    }
  },

  deleteChatGroupThroughConversations: ({ commit }, id) => {
    // commit(types.DELETE_CONTACT, id);
    commit(types.CLEAR_CHAT_GROUP_CONVERSATIONS, id, { root: true });
    // commit(`contactConversations/${types.DELETE_CONTACT_CONVERSATION}`, id, {
    //   root: true,
    // });
  },
};
